import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export const StarIcon = (props: IconProps): ReactElement => (
  <IconWrapper {...props}>
    <path d="M12 .935l2.809 8.438h9.09l-7.354 5.214 2.809 8.438L12 17.81l-7.354 5.215 2.809-8.438L.1 9.373h9.091L12 .935z" />
  </IconWrapper>
);
